// IMPORTS
// Modules
import { useEffect, useRef } from 'react';
import { Network } from 'vis-network/peer/esm/vis-network';
import { DataSet } from 'vis-data/peer/esm/vis-data';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './PortTopology.scss';
import "vis-network/styles/vis-network.css";
import { topologyOptionsLight } from './_variables';
import { topologyOptionsDark } from './_variables';


// COMPONENT
export default function PortTopology (props) {
   // States and Variables
   const topology = useRef(null);
   const topologyContainer = useRef(null);
   const topologyNodes = useRef(new DataSet([]));
   const topologyEdges = useRef(new DataSet([]));
   var alreadyLoading = false; // used to prevent double loading of topology due to theme changing

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Port Topology"); // set page title
      buildTopology();
   }, []);

   // Listeners
   useEffect(function () {
      if (!alreadyLoading) {
         buildTopology(); // rebuild navigation when theme changes
      }
   }, [props.onehive.theme]);

   // Functions
   const buildTopology = function () {
      alreadyLoading = true;
      OHSCRUD({
         url: '/v1/oneport/devices/topology',
         method: 'GET',
         success: function (data) {
            topologyNodes.current = new DataSet(data.nodes);
            topologyEdges.current = new DataSet(data.edges);
            topology.current = new Network(
               topologyContainer.current,
               {
                  nodes: topologyNodes.current,
                  edges: topologyEdges.current
               },
               props.onehive.theme === props.onehive.themes.light ? topologyOptionsLight : topologyOptionsDark
            );
         },
         always: function () {
            alreadyLoading = false;
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      })
      
   }

   // Component
   return (
      <div className="oneport-porttopology">
         <OHSAppHeader onehive={props.onehive} title="Port Topology" help="https://www.onehivesystems.com/documentation/oneport/porttopology" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} title="Topology Map">
               <div className='oneport-porttopology-topology'>
                  <div ref={topologyContainer} className='oneport-porttopology-topology-map'></div>
                  <div className='oneport-porttopology-disclaimer'>
                     <p>Topology visualization by <a href='https://www.visjs.org/' target='_blank'>Vis.js</a> - usage under general use license</p>
                  </div>
                  <div className='oneport-porttopology-topology-options'>
                     <button className='ohsbtn-success' onClick={buildTopology}>Refresh Topology</button>
                  </div>
               </div>
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}